(function($) {

  // set "class_foo" class on motopress row. This routine will turn that into
  // an ID for that row so it can be referenced as an anchor.
  /*
  can be set directly now...

  $('div.motopress-row').each(function() {
    var row = $(this);
    $.each($(this).attr('class').split(' '), function() {
      if (this.indexOf('anchor_') == 0) {
        row.attr('id', this.split('_')[1]);
      }
    });
  });
  */

  // handle nav auto scroll to 
  $('nav#site-navigation .menu-item a').on('click', function() {
    $('button.menu-toggle').click();
    var link = this;
    var to = $(this.hash).offset().top - 80;
    $(window).stop(true).scrollTo(to, {duration:1000, interrupt:true, onAfter: function() {
      //location.hash = link.hash;

    }});

    return false;
  });

  if ($('body').hasClass('home')) {
    // handle navbar fancy stickyness
    $(window).on('load resize orientationchange scroll', function() {
      if ($(window).scrollTop() == 0) {
        $('body').addClass('at_top').removeClass('not_at_top');
      }
      else {
        $('body').removeClass('at_top').addClass('not_at_top');
      }

      var first_parallax = $('.motopress-row-parallax.mp-row-fullwidth:first');
      if ((first_parallax.offset().top + first_parallax.height()) < $(window).scrollTop()) {
        $('body').addClass('below_first_parallax');
      }
      else {
        $('body').removeClass('below_first_parallax');
      }

      var masthead = $('header#masthead');
      if ((masthead.offset().top + masthead.height()) < $(window).scrollTop()) {
        $('body').addClass('masthead_out_of_view');
      }
      else {
        $('body').removeClass('masthead_out_of_view');
      }
    });

    // equal height diensten columns
    $('.motopress-posts-grid-obj').each(function() {
      var tallest;
      $(this).find('.motopress-posts-grid-content').each(function() {
        if (!tallest || $(this).height() > tallest) {
          tallest = $(this).height();
        }
      });
      if (tallest) {
        $(this).find('.motopress-posts-grid-content').height(tallest);
      }
    });

    // leveranciers links from captions
    $('#leveranciers .motopress-grid-gallery-obj a').attr('href', function() {
      return $(this).find('img').prop('alt');
    });
  }



  // load inline realisaties before/after on visible. Handy for mobile which doesnt have the hover state. 
  $('div.inline-realisatie')
    .imagesLoaded(function(){
      $(this.elements).removeAttr('data-loading');
    })
    .find('h4').dotdotdot();
  // separated to keep as much out of the scroll handler as possible
  function realisatiesOnScroll() {
    $('div.inline-realisatie').not('[data-loading], [data-done]').each(function(i, item) {
      if ($(item).visible(true)) {
        $(item)
          .attr('data-done', true)
          .find('a')
            .addClass('hover');
        _.delay(function() {
          $(item).find('a').removeClass('hover');
        }, 3000 + (200 * i));
      }
    });
  }
  $(window).on('scroll', _.debounce(function() {
    realisatiesOnScroll();
  }, 300)).scroll();

})(jQuery);